import { StatusHistoryTable } from "pages/cases-dashboard/components/status-history-table";
import styles from "./styles.module.scss";
import { useLanguageTranslator } from "hooks/use-language-translator";

export const CaseStatusHistory = ({ case_id }) => {
  const { translator } = useLanguageTranslator();

  return (
    <div className={styles.caseStatusHistory}>
      <h2 className={styles.heading}>
        {translator("casesTable.caseStatusHistory")}
      </h2>
      <StatusHistoryTable data={[]} case_id={case_id} />
    </div>
  );
};
